import React from "react"
import { View } from "react-native"
import styles from "./styles"
import { OpenSansText } from "@Components/CustomText/OpenSansText"
import { baseFontFamily } from "@Constants/baseStyles"

const NoticeConsentItem = ({ label, value, subContent }) => {
    return (
        <View style={[styles.container, { marginBottom: 10 }]}>
            <OpenSansText
                defaultFontFamily={baseFontFamily.OpenSansRegular}
                style={{ fontStyle: "italic" }}
                fontSize={14}
            >
                {label}
            </OpenSansText>

            <OpenSansText defaultFontFamily={baseFontFamily.OpenSansSemiBold} fontSize={12}>
                {value}
            </OpenSansText>

            {subContent && (
                <OpenSansText defaultFontFamily={baseFontFamily.OpenSansSemiBold} fontSize={12}>
                    {subContent}
                </OpenSansText>
            )}
        </View>
    )
}

export default NoticeConsentItem
